import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { SweetShopArticlesPageState } from './state';
import { SweetShopArticlesPageActions } from './actions';
import BaseError from '../../../utils/base-error';
import {
    createSweetShopArticleCategoryFromGetSweetShopArticleCategoryByUidApiResponse,
    createSweetShopArticleCategoryTagsFromGetSweetShopArticleCategoryTagsByCategoryUidApiResponse,
    createSweetShopArticlesFromGetSweetShopArticlesByCategoryUidAndTagUidApiResponse,
} from '../utils';

const initialState: SweetShopArticlesPageState = {
    loaded: false,
    errors: [],
    sweetShopArticleCategoryTags: [],
    sweetShopArticles: [],
};

export const sweetShopArticlesPageSlice = createSlice({
    name: 'sweetShopArticlesPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        /**
         * Обработчик получения списка типов баров (коллекция OutdoorBarType)
         */
        builder.addCase(
            SweetShopArticlesPageActions.getSweetShopArticleCategoryByUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createSweetShopArticleCategoryFromGetSweetShopArticleCategoryByUidApiResponse(
                            response.data,
                        );

                        state.sweetShopArticleCategory = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        /**
         * Обработчик получения списка типов баров (коллекция OutdoorBarType)
         */
        builder.addCase(
            SweetShopArticlesPageActions.getSweetShopArticleCategoryTagsByCategoryUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createSweetShopArticleCategoryTagsFromGetSweetShopArticleCategoryTagsByCategoryUidApiResponse(
                            response.data,
                        );

                        state.sweetShopArticleCategoryTags = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );

        /**
         * Обработчик получения списка типов баров (коллекция OutdoorBarType)
         */
        builder.addCase(
            SweetShopArticlesPageActions.getSweetShopArticlesByCategoryUidAndTagUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createSweetShopArticlesFromGetSweetShopArticlesByCategoryUidAndTagUidApiResponse(
                            response.data,
                        );

                        state.sweetShopArticles = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
